import SoftSelect from "components/SoftSelect";
import MuiTextField from "@mui/material/TextField";
import SoftBox from "components/SoftBox";
import { styled } from "@mui/material/styles";
import { THEME_COLORS, THEME_TYPES } from "constants/theme";
import typography from "assets/theme/base/typography";

const { fontWeightLight } = typography;

export const StyledSelect = styled(SoftSelect)(({ placeholder }) => ({
   width: "100%",
   marginTop: placeholder?.toLowerCase() !== "" ? (placeholder?.toLowerCase() === "credential" ? "25px" : "35px") : "16px",
   "& .select-placeholder-container": {
      marginLeft: "-14px",
      marginTop: "-20px",
      position: "relative",
      top: "-80%",
      left: 0,
      whiteSpace: "nowrap",
      maxWidth: "100%",
      fontSize: "14px !important",
      fontWeight: `${fontWeightLight} !important`
   },
   "&.variable-reference-select .select-placeholder-container": {
      fontSize: "13px !important",
      fontWeight: "600 !important"
   }
}));

export const TextField = styled(MuiTextField, {
   shouldForwardProp: (prop) => prop !== "slotProps" && prop !== "slotProps"
})(({ theme }) => ({
   position: "relative",
   zIndex: 0,
   "--disabled-input-bg": theme.palette.mode === THEME_TYPES.DARK ? "var(--input-bg-color)" : THEME_COLORS.LIGHT.DISABLED_BG,
   "--disabled-input-border": theme.palette.mode === THEME_TYPES.DARK ? "var(--input-border-color)" : "rgba(0, 0, 0, 0.23)",
   "--disabled-input-text": theme.palette.mode === THEME_TYPES.DARK ? "rgba(255, 255, 255, 0.45)" : theme.palette.text.secondary,

   // Label above the field
   "& .MuiInputLabel-root": {
      position: "relative",
      transform: "none",
      top: 0,
      left: 0,
      marginBottom: "6px",
      fontSize: "13px",
      fontWeight: 600,
      color: theme.palette.text.primary,
      zIndex: 0,
      pointerEvents: "none"
   },
   "& .MuiInputLabel-root.Mui-disabled": {
      color: theme.palette.text.primary,
      opacity: 1
   },

   "& .MuiInputLabel-shrink": {
      transform: "none !important"
   },

   "& .MuiInputLabel-asterisk": {
      color: theme.palette.error.main,
      marginLeft: "2px"
   },

   "& .MuiOutlinedInput-root": {
      borderRadius: "0.5rem !important",
      backgroundColor: theme.palette.mode === THEME_TYPES.DARK ? "var(--input-bg-color)" : theme.palette.background.paper,
      border: `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
      zIndex: 1,
      "& .MuiOutlinedInput-notchedOutline": {
         display: "none"
      },
      "&.Mui-focused": {
         borderColor: "#35d1f5",
         boxShadow: "0rem 0rem 0rem 0.125rem rgba(116, 67, 255, 1);",
         outline: 0
      }
   },

   "& .MuiInputBase-root.Mui-disabled, & .MuiOutlinedInput-root.Mui-disabled, & .MuiFilledInput-root.Mui-disabled": {
      backgroundColor: "var(--disabled-input-bg) !important",
      borderColor: "var(--disabled-input-border) !important",
      opacity: 1
   },

   "& .MuiInputBase-input": {
      padding: "10px 14px",
      fontSize: "14px",
      color: theme.palette.text.secondary,
      width: "100%"
   },

   "& .MuiInputBase-input.Mui-disabled, & .MuiAutocomplete-input.Mui-disabled": {
      color: "var(--disabled-input-text) !important",
      WebkitTextFillColor: "var(--disabled-input-text) !important",
      opacity: 1
   }
}));

export const ValueInputWrapper = styled(SoftBox)(() => ({
   display: "flex",
   flexDirection: "row",
   alignItems: "center",
   justifyContent: "space-between",
   width: "100%",
   marginTop: "8px",

   "& > div:first-of-type": {
      flexGrow: 1
   }
}));
